import e from "../../hooks/useAfterMount.js";
import "../../useAfterMount.js";
import { Children as t, isValidElement as n, useState as r } from "react";
import { noop as i } from "es-toolkit/compat";
import { AnimatePresence as a, motion as o, useReducedMotion as s } from "motion/react";
import { jsx as c } from "react/jsx-runtime";
//#region src/components/fade/Fade.tsx
var l = {
	fromLeft: {
		initial: {
			x: -10,
			y: 0,
			opacity: 0
		},
		animate: {
			x: 0,
			y: 0,
			opacity: 1
		},
		exit: {
			x: -10,
			y: 0,
			opacity: 0
		}
	},
	fromRight: {
		initial: {
			x: 10,
			y: 0,
			opacity: 0
		},
		animate: {
			x: 0,
			y: 0,
			opacity: 1
		},
		exit: {
			x: 10,
			y: 0,
			opacity: 0
		}
	},
	fromTop: {
		initial: {
			y: -10,
			x: 0,
			opacity: 0
		},
		animate: {
			y: 0,
			x: 0,
			opacity: 1
		},
		exit: {
			y: -10,
			x: 0,
			opacity: 0
		}
	},
	fromBottom: {
		initial: {
			y: 10,
			x: 0,
			opacity: 0
		},
		animate: {
			y: 0,
			x: 0,
			opacity: 1
		},
		exit: {
			y: 10,
			x: 0,
			opacity: 0
		}
	},
	fade: {
		initial: {
			x: 0,
			y: 0,
			opacity: 0
		},
		animate: {
			x: 0,
			y: 0,
			opacity: 1
		},
		exit: {
			x: 0,
			y: 0,
			opacity: 0
		}
	},
	tabs: {
		initial: {
			x: 2,
			y: 0,
			opacity: 0
		},
		animate: {
			x: 0,
			y: 0,
			opacity: 1
		},
		exit: {
			x: -2,
			y: 0,
			opacity: 0
		}
	},
	page: {
		initial: "pageEnter",
		animate: "pageCenter",
		exit: "pageExit"
	},
	pageBack: {
		initial: "pageEnter",
		animate: "pageCenter",
		exit: "pageExit"
	}
}, u = (e) => e === "pageBack" ? -1 : 1, d = {
	pageEnter: (e) => ({
		x: `${e * 60}%`,
		opacity: 0
	}),
	pageCenter: {
		x: 0,
		opacity: 1
	},
	pageExit: (e) => ({
		zIndex: 0,
		x: `${-e * 60}%`,
		opacity: 0
	})
}, f = {
	initial: !1,
	animate: {
		x: 0,
		y: 0,
		opacity: 1
	},
	exit: {
		x: 0,
		y: 0,
		opacity: 1
	}
}, p = (p) => {
	let { show: m = !0, initial: h = !1, duration: g = .2, exitBeforeEnter: _ = !1, animationStyle: v = "fade", animatePresenceProps: y, motionProps: b, onExitComplete: x = i, children: S } = p, [C, w] = r(h), T = s();
	e(() => {
		C || w(!0);
	});
	let [E] = t.toArray(S), D = n(E) && E.key !== null ? `fade-${E.key}` : "fade", O = v === "page" || v === "pageBack", k = u(v), A = O ? k : null, j = O ? { variants: d } : null, M = T ? f : l[v], N = C && !T ? M.initial : !1, P = {
		...M,
		initial: N
	};
	return /* @__PURE__ */ c(a, {
		initial: C,
		mode: _ ? "wait" : "sync",
		onExitComplete: x,
		custom: A,
		...y,
		children: m && /* @__PURE__ */ c(o.div, {
			transition: { duration: T ? 0 : g },
			custom: A,
			...P,
			...j,
			...b,
			children: S
		}, D)
	});
};
p.FADE = "fade", p.FROM_LEFT = "fromLeft", p.FROM_RIGHT = "fromRight", p.FROM_TOP = "fromTop", p.FROM_BOTTOM = "fromBottom", p.TABS = "tabs", p.PAGE = "page", p.PAGE_BACK = "pageBack";
//#endregion
export { p as default };

//# sourceMappingURL=Fade.js.map